import createRelativeImageURL from '@/utils/createRelativeImageURL';
import { seoSegmentationListingPage } from '@/__generated__/seoSegmentationListingPage';

/**
 * This function returns the default large hero image from the SEO Segmentation Hero Image.
 * If the hero image is not available, it returns null.
 * @param {seoSegmentationListingPage['seoSegmentationHeroImage']} seoSegmentationHeroImage
 * @returns {string | null} - The default hero image URL or null if not available.
 */

export const getDefaultHeroImageLarge = (
  seoSegmentationHeroImage: seoSegmentationListingPage['seoSegmentationHeroImage']
): string | null => {
  if (
    seoSegmentationHeroImage.__typename === 'SEOSegmentationHeroImageSuccess' &&
    seoSegmentationHeroImage.heroImage
  ) {
    return createRelativeImageURL(seoSegmentationHeroImage.heroImage.largeImageURL);
  }
  return null;
};
